import TaskManagementBase from './TaskManagementBase';

export default function DigitalDesign({ user }) {
  return (
    <TaskManagementBase
      user={user}
      moduleName="Digital Design"
      moduleTitle="Digital Design"
      moduleDescription="Digital design creation, mockups, and artwork management"
    />
  );
}
